
import { Component, Vue } from 'vue-property-decorator'
import { AffiliateModule } from '../../store'
import TrustPilot from '@/components/shared/TrustPilot.vue'

    @Component({
      name: 'PartnerRepAprModelV3',
      components: {
        TrustPilot
      }
    })
export default class PartnerRepAprModel extends Vue {
  // #region Computed

  get imgUrl () {
    return require('@/assets' + this.logoPath)
  }

  get modalShowLogo () {
    return AffiliateModule.affiliateConfig && AffiliateModule.affiliateConfig.modalShowLogo && AffiliateModule.affiliateConfig.modalShowLogo === true
  }

  get logoPath () {
    return AffiliateModule.affiliateConfig ? AffiliateModule.affiliateConfig.logoPath : ''
  }

  get logoAlt () {
    return AffiliateModule.affiliateConfig ? AffiliateModule.affiliateConfig.displayName + ' logo' : ''
  }

	get swapLogo () {
		return AffiliateModule.affiliateConfig && AffiliateModule.affiliateConfig.swapLogo && AffiliateModule.affiliateConfig.swapLogo === true
	}

	get powerbyLogo () {
		return AffiliateModule.affiliateConfig && AffiliateModule.affiliateConfig['useModelV3PowerBy'] && AffiliateModule.affiliateConfig['useModelV3PowerBy'] === true
	}

  get displayName () {
		return AffiliateModule.affiliateConfig && AffiliateModule.affiliateConfig.displayName ? `${AffiliateModule.affiliateConfig.displayName} have partnered with CarFinance 247`  : 'Partnered with CarFinance 247'
	}

  // #endregion

  // #region Methods

  close () {
    this.$emit('close')
  }

  // #endregion

  // #region Computed

  get host () {
    return AffiliateModule.host
  }

  // #endregion
}
